module.exports = __webpack_public_path__ + "static/media/thumb.627dbc3b.jpg";